// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-b318b0e4] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.counter-bubble__counter[data-v-b318b0e4] {
  font-size: calc(var(--default-font-size) * .8);
  overflow: hidden;
  width: fit-content;
  max-width: 44px;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 1em;
  padding: 4px 6px;
  border-radius: var(--border-radius-pill);
  background-color: var(--color-primary-element-light);
  font-weight: 700;
  color: var(--color-primary-element-light-text);
}
.counter-bubble__counter .active[data-v-b318b0e4] {
  color: var(--color-main-background);
  background-color: var(--color-primary-element-light);
}
.counter-bubble__counter--highlighted[data-v-b318b0e4] {
  color: var(--color-primary-element-text);
  background-color: var(--color-primary-element);
}
.counter-bubble__counter--highlighted.active[data-v-b318b0e4] {
  color: var(--color-primary-element);
  background-color: var(--color-main-background);
}
.counter-bubble__counter--outlined[data-v-b318b0e4] {
  color: var(--color-primary-element);
  background: transparent;
  box-shadow: inset 0 0 0 2px;
}
.counter-bubble__counter--outlined.active[data-v-b318b0e4] {
  color: var(--color-main-background);
  box-shadow: inset 0 0 0 2px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-17673ea1.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,oDAAoD;EACpD,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,mCAAmC;EACnC,oDAAoD;AACtD;AACA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;AACA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-b318b0e4] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.counter-bubble__counter[data-v-b318b0e4] {\n  font-size: calc(var(--default-font-size) * .8);\n  overflow: hidden;\n  width: fit-content;\n  max-width: 44px;\n  text-align: center;\n  text-overflow: ellipsis;\n  line-height: 1em;\n  padding: 4px 6px;\n  border-radius: var(--border-radius-pill);\n  background-color: var(--color-primary-element-light);\n  font-weight: 700;\n  color: var(--color-primary-element-light-text);\n}\n.counter-bubble__counter .active[data-v-b318b0e4] {\n  color: var(--color-main-background);\n  background-color: var(--color-primary-element-light);\n}\n.counter-bubble__counter--highlighted[data-v-b318b0e4] {\n  color: var(--color-primary-element-text);\n  background-color: var(--color-primary-element);\n}\n.counter-bubble__counter--highlighted.active[data-v-b318b0e4] {\n  color: var(--color-primary-element);\n  background-color: var(--color-main-background);\n}\n.counter-bubble__counter--outlined[data-v-b318b0e4] {\n  color: var(--color-primary-element);\n  background: transparent;\n  box-shadow: inset 0 0 0 2px;\n}\n.counter-bubble__counter--outlined.active[data-v-b318b0e4] {\n  color: var(--color-main-background);\n  box-shadow: inset 0 0 0 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
